export default __webpack_public_path__ + "static/media/orientation_CORE.49d744c1.png";